/**
 * Contact Form 7 → dataLayer
 *
 * Accodato da inc/tracking.php solo quando GTM è attivo e CF7 è installato.
 * Invia un evento a ogni invio riuscito (mail inviata), da usare in GTM come
 * trigger "Evento personalizzato" per le conversioni.
 *
 * Nome evento "cf7_mail_sent" (non "form_submit") per non collidere con
 * l'evento omonimo della misurazione avanzata di GA4.
 */
document.addEventListener('wpcf7mailsent', (event) => {
	const detail = event.detail || {};
	const form = event.target instanceof HTMLFormElement ? event.target : null;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'cf7_mail_sent',
		form_id: String(detail.contactFormId || ''),
		// CF7 imposta il titolo del form come aria-label del <form>.
		form_name: (form && form.getAttribute('aria-label')) || '',
		form_unit_tag: detail.unitTag || '',
	});
});
